// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.14.0 (commit 3ac273e970212dd613e57f4c312c49a9ab8ccb50).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AcknowledgeAlertEventReducer from "./acknowledge_alert_event_reducer";
import AddAlertTargetReducer from "./add_alert_target_reducer";
import CleanupOrphanedStreamsReducer from "./cleanup_orphaned_streams_reducer";
import ClearAlertEventsReducer from "./clear_alert_events_reducer";
import ClearAllDataReducer from "./clear_all_data_reducer";
import ClearOldPollLogsReducer from "./clear_old_poll_logs_reducer";
import ClearStoppedPollsReducer from "./clear_stopped_polls_reducer";
import CreateAlertRuleReducer from "./create_alert_rule_reducer";
import CreateComputedChannelReducer from "./create_computed_channel_reducer";
import CreateNewStreamReducer from "./create_new_stream_reducer";
import CreateResponseMappingReducer from "./create_response_mapping_reducer";
import CreateRestEndpointReducer from "./create_rest_endpoint_reducer";
import DeleteAlertRuleReducer from "./delete_alert_rule_reducer";
import DeleteComputedChannelReducer from "./delete_computed_channel_reducer";
import DeleteOpenapiSpecReducer from "./delete_openapi_spec_reducer";
import DeleteResponseMappingReducer from "./delete_response_mapping_reducer";
import DeleteRestCredentialsReducer from "./delete_rest_credentials_reducer";
import DeleteRestEndpointReducer from "./delete_rest_endpoint_reducer";
import DeleteStreamByStreamNameReducer from "./delete_stream_by_stream_name_reducer";
import DisableRestEndpointReducer from "./disable_rest_endpoint_reducer";
import DismissAlertEventReducer from "./dismiss_alert_event_reducer";
import DismissAlertNotificationReducer from "./dismiss_alert_notification_reducer";
import EnableRestEndpointReducer from "./enable_rest_endpoint_reducer";
import ExportAllTelemetryReducer from "./export_all_telemetry_reducer";
import ExportTelemetryByStreamIdReducer from "./export_telemetry_by_stream_id_reducer";
import ExportTelemetryByStreamNameReducer from "./export_telemetry_by_stream_name_reducer";
import ExportTelemetryStreamsReducer from "./export_telemetry_streams_reducer";
import GetModuleInfoReducer from "./get_module_info_reducer";
import ImportDtdlGraphFromJsonReducer from "./import_dtdl_graph_from_json_reducer";
import ImportTelemetryFromJsonReducer from "./import_telemetry_from_json_reducer";
import ImportTelemetryFromJsonWithStringModeReducer from "./import_telemetry_from_json_with_string_mode_reducer";
import ListAlertTargetsReducer from "./list_alert_targets_reducer";
import MapResponseFieldReducer from "./map_response_field_reducer";
import PauseRestPollingReducer from "./pause_rest_polling_reducer";
import PostRestoreNormalizeReducer from "./post_restore_normalize_reducer";
import RegisterAdminServiceReducer from "./register_admin_service_reducer";
import RemoveAlertTargetReducer from "./remove_alert_target_reducer";
import RemoveModuleUserReducer from "./remove_module_user_reducer";
import ReparseOpenapiSpecReducer from "./reparse_openapi_spec_reducer";
import ReplaceOpenapiSpecReducer from "./replace_openapi_spec_reducer";
import ResumeRestPollingReducer from "./resume_rest_polling_reducer";
import SendComplexTelemetryByStreamIdReducer from "./send_complex_telemetry_by_stream_id_reducer";
import SendComplexTelemetryByStreamNameReducer from "./send_complex_telemetry_by_stream_name_reducer";
import SendLocationByStreamIdReducer from "./send_location_by_stream_id_reducer";
import SendLocationByStreamNameReducer from "./send_location_by_stream_name_reducer";
import SendRotationByStreamIdReducer from "./send_rotation_by_stream_id_reducer";
import SendRotationByStreamNameReducer from "./send_rotation_by_stream_name_reducer";
import SendTelemetryBatchReducer from "./send_telemetry_batch_reducer";
import SendTelemetryBoolByStreamIdReducer from "./send_telemetry_bool_by_stream_id_reducer";
import SendTelemetryBoolByStreamNameReducer from "./send_telemetry_bool_by_stream_name_reducer";
import SendTelemetryByteByStreamIdReducer from "./send_telemetry_byte_by_stream_id_reducer";
import SendTelemetryByteByStreamNameReducer from "./send_telemetry_byte_by_stream_name_reducer";
import SendTelemetryBytesByStreamIdReducer from "./send_telemetry_bytes_by_stream_id_reducer";
import SendTelemetryBytesByStreamNameReducer from "./send_telemetry_bytes_by_stream_name_reducer";
import SendTelemetryDateByStreamIdReducer from "./send_telemetry_date_by_stream_id_reducer";
import SendTelemetryDateByStreamNameReducer from "./send_telemetry_date_by_stream_name_reducer";
import SendTelemetryDateTimeByStreamIdReducer from "./send_telemetry_date_time_by_stream_id_reducer";
import SendTelemetryDateTimeByStreamNameReducer from "./send_telemetry_date_time_by_stream_name_reducer";
import SendTelemetryDecimalByStreamIdReducer from "./send_telemetry_decimal_by_stream_id_reducer";
import SendTelemetryDecimalByStreamNameReducer from "./send_telemetry_decimal_by_stream_name_reducer";
import SendTelemetryDoubleByStreamIdReducer from "./send_telemetry_double_by_stream_id_reducer";
import SendTelemetryDoubleByStreamNameReducer from "./send_telemetry_double_by_stream_name_reducer";
import SendTelemetryDurationByStreamIdReducer from "./send_telemetry_duration_by_stream_id_reducer";
import SendTelemetryDurationByStreamNameReducer from "./send_telemetry_duration_by_stream_name_reducer";
import SendTelemetryFloatByStreamIdReducer from "./send_telemetry_float_by_stream_id_reducer";
import SendTelemetryFloatByStreamNameReducer from "./send_telemetry_float_by_stream_name_reducer";
import SendTelemetryIntegerByStreamIdReducer from "./send_telemetry_integer_by_stream_id_reducer";
import SendTelemetryIntegerByStreamNameReducer from "./send_telemetry_integer_by_stream_name_reducer";
import SendTelemetryLongByStreamIdReducer from "./send_telemetry_long_by_stream_id_reducer";
import SendTelemetryLongByStreamNameReducer from "./send_telemetry_long_by_stream_name_reducer";
import SendTelemetryShortByStreamIdReducer from "./send_telemetry_short_by_stream_id_reducer";
import SendTelemetryShortByStreamNameReducer from "./send_telemetry_short_by_stream_name_reducer";
import SendTelemetryStringByStreamIdReducer from "./send_telemetry_string_by_stream_id_reducer";
import SendTelemetryStringByStreamNameReducer from "./send_telemetry_string_by_stream_name_reducer";
import SendTelemetryTimeByStreamIdReducer from "./send_telemetry_time_by_stream_id_reducer";
import SendTelemetryTimeByStreamNameReducer from "./send_telemetry_time_by_stream_name_reducer";
import SendTelemetryUnsignedByteByStreamIdReducer from "./send_telemetry_unsigned_byte_by_stream_id_reducer";
import SendTelemetryUnsignedByteByStreamNameReducer from "./send_telemetry_unsigned_byte_by_stream_name_reducer";
import SendTelemetryUnsignedIntegerByStreamIdReducer from "./send_telemetry_unsigned_integer_by_stream_id_reducer";
import SendTelemetryUnsignedIntegerByStreamNameReducer from "./send_telemetry_unsigned_integer_by_stream_name_reducer";
import SendTelemetryUnsignedLongByStreamIdReducer from "./send_telemetry_unsigned_long_by_stream_id_reducer";
import SendTelemetryUnsignedLongByStreamNameReducer from "./send_telemetry_unsigned_long_by_stream_name_reducer";
import SendTelemetryUnsignedShortByStreamIdReducer from "./send_telemetry_unsigned_short_by_stream_id_reducer";
import SendTelemetryUnsignedShortByStreamNameReducer from "./send_telemetry_unsigned_short_by_stream_name_reducer";
import SendTelemetryUuidByStreamIdReducer from "./send_telemetry_uuid_by_stream_id_reducer";
import SendTelemetryUuidByStreamNameReducer from "./send_telemetry_uuid_by_stream_name_reducer";
import SendTransformByStreamIdReducer from "./send_transform_by_stream_id_reducer";
import SendTransformByStreamNameReducer from "./send_transform_by_stream_name_reducer";
import SetAlertConditionV2Reducer from "./set_alert_condition_v_2_reducer";
import SetChannelAggregateV2Reducer from "./set_channel_aggregate_v_2_reducer";
import SetChannelEnabledReducer from "./set_channel_enabled_reducer";
import SetChannelSequenceOpReducer from "./set_channel_sequence_op_reducer";
import SetModuleUserRoleReducer from "./set_module_user_role_reducer";
import SetProjectScopeReducer from "./set_project_scope_reducer";
import SetProjectTenantConfigReducer from "./set_project_tenant_config_reducer";
import SetResponseMappingScaleReducer from "./set_response_mapping_scale_reducer";
import SetRestCredentialsReducer from "./set_rest_credentials_reducer";
import StartAlertEvaluatorReducer from "./start_alert_evaluator_reducer";
import StartAlertHistoryGcReducer from "./start_alert_history_gc_reducer";
import StartAlertWebhookDeliveryReducer from "./start_alert_webhook_delivery_reducer";
import StartChannelEngineReducer from "./start_channel_engine_reducer";
import StartRestPollLogGcReducer from "./start_rest_poll_log_gc_reducer";
import StartRestPollingReducer from "./start_rest_polling_reducer";
import StopAlertEvaluatorReducer from "./stop_alert_evaluator_reducer";
import StopAlertWebhookDeliveryReducer from "./stop_alert_webhook_delivery_reducer";
import StopAllRestPollingReducer from "./stop_all_rest_polling_reducer";
import StopChannelEngineReducer from "./stop_channel_engine_reducer";
import StopRestPollingReducer from "./stop_rest_polling_reducer";
import ToggleAlertRuleReducer from "./toggle_alert_rule_reducer";
import ToggleAlertTargetReducer from "./toggle_alert_target_reducer";
import TransferAdminServiceReducer from "./transfer_admin_service_reducer";
import UnmapResponseFieldReducer from "./unmap_response_field_reducer";
import UpdateAlertRuleReducer from "./update_alert_rule_reducer";
import UpdateComputedChannelReducer from "./update_computed_channel_reducer";
import UpdateResponseMappingReducer from "./update_response_mapping_reducer";
import UpdateRestEndpointReducer from "./update_rest_endpoint_reducer";
import UpdateStreamNameByStreamIdReducer from "./update_stream_name_by_stream_id_reducer";
import UploadOpenapiSpecReducer from "./upload_openapi_spec_reducer";

// Import all procedure arg schemas
import * as ReplayTelemetryProcedure from "./replay_telemetry_procedure";
import * as ReplayTransformsProcedure from "./replay_transforms_procedure";
import * as TelemetryWindowProcedure from "./telemetry_window_procedure";
import * as TestRestEndpointProcedure from "./test_rest_endpoint_procedure";
import * as TransformWindowProcedure from "./transform_window_procedure";

// Import all table schema definitions
import AlertEventRow from "./alert_event_table";
import AlertRuleRow from "./alert_rule_table";
import AlertTargetListEventRow from "./alert_target_list_event_table";
import ComplexTelemetryRow from "./complex_telemetry_table";
import ComputedChannelRow from "./computed_channel_table";
import ExportResultEventRow from "./export_result_event_table";
import ModuleUserRow from "./module_user_table";
import PrimitiveTelemetryBoolRow from "./primitive_telemetry_bool_table";
import PrimitiveTelemetryByteRow from "./primitive_telemetry_byte_table";
import PrimitiveTelemetryBytesRow from "./primitive_telemetry_bytes_table";
import PrimitiveTelemetryDateRow from "./primitive_telemetry_date_table";
import PrimitiveTelemetryDateTimeRow from "./primitive_telemetry_date_time_table";
import PrimitiveTelemetryDecimalRow from "./primitive_telemetry_decimal_table";
import PrimitiveTelemetryDoubleRow from "./primitive_telemetry_double_table";
import PrimitiveTelemetryDurationRow from "./primitive_telemetry_duration_table";
import PrimitiveTelemetryFloatRow from "./primitive_telemetry_float_table";
import PrimitiveTelemetryIntegerRow from "./primitive_telemetry_integer_table";
import PrimitiveTelemetryLongRow from "./primitive_telemetry_long_table";
import PrimitiveTelemetryShortRow from "./primitive_telemetry_short_table";
import PrimitiveTelemetryStringRow from "./primitive_telemetry_string_table";
import PrimitiveTelemetryTimeRow from "./primitive_telemetry_time_table";
import PrimitiveTelemetryUnsignedByteRow from "./primitive_telemetry_unsigned_byte_table";
import PrimitiveTelemetryUnsignedIntegerRow from "./primitive_telemetry_unsigned_integer_table";
import PrimitiveTelemetryUnsignedLongRow from "./primitive_telemetry_unsigned_long_table";
import PrimitiveTelemetryUnsignedShortRow from "./primitive_telemetry_unsigned_short_table";
import PrimitiveTelemetryUuidRow from "./primitive_telemetry_uuid_table";
import ProjectAlertNotificationRow from "./project_alert_notification_table";
import RestApiSpecRow from "./rest_api_spec_table";
import RestEndpointRow from "./rest_endpoint_table";
import RestPollLogRow from "./rest_poll_log_table";
import RestPollingRow from "./rest_polling_table";
import RestResponseMappingRow from "./rest_response_mapping_table";
import TwinTransformRow from "./twin_transform_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  alertEvent: __table({
    name: 'alert_event',
    indexes: [
      { accessor: 'id', name: 'alert_event_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'project_id', name: 'alert_event_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'rule_id', name: 'alert_event_rule_id_idx_btree', algorithm: 'btree', columns: [
        'ruleId',
      ] },
    ],
    constraints: [
      { name: 'alert_event_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AlertEventRow),
  alertRule: __table({
    name: 'alert_rule',
    indexes: [
      { accessor: 'id', name: 'alert_rule_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'project_id', name: 'alert_rule_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
      { accessor: 'stream_name', name: 'alert_rule_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'alert_rule_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AlertRuleRow),
  alertTargetListEvent: __table({
    name: 'alert_target_list_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, AlertTargetListEventRow),
  complexTelemetry: __table({
    name: 'complex_telemetry',
    indexes: [
      { accessor: 'stream_id', name: 'complex_telemetry_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'complex_telemetry_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'complex_telemetry_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'complex_telemetry_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, ComplexTelemetryRow),
  computedChannel: __table({
    name: 'computed_channel',
    indexes: [
      { accessor: 'id', name: 'computed_channel_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'input_stream_name', name: 'computed_channel_input_stream_name_idx_btree', algorithm: 'btree', columns: [
        'inputStreamName',
      ] },
      { accessor: 'output_stream_name', name: 'computed_channel_output_stream_name_idx_btree', algorithm: 'btree', columns: [
        'outputStreamName',
      ] },
      { accessor: 'project_id', name: 'computed_channel_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
    ],
    constraints: [
      { name: 'computed_channel_id_key', constraint: 'unique', columns: ['id'] },
      { name: 'computed_channel_output_stream_name_key', constraint: 'unique', columns: ['outputStreamName'] },
    ],
  }, ComputedChannelRow),
  exportResultEvent: __table({
    name: 'export_result_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, ExportResultEventRow),
  moduleUser: __table({
    name: 'module_user',
    indexes: [
      { accessor: 'identity', name: 'module_user_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'module_user_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, ModuleUserRow),
  primitiveTelemetryBool: __table({
    name: 'primitive_telemetry_bool',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_bool_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_bool_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_bool_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_bool_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryBoolRow),
  primitiveTelemetryByte: __table({
    name: 'primitive_telemetry_byte',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_byte_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_byte_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_byte_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_byte_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryByteRow),
  primitiveTelemetryBytes: __table({
    name: 'primitive_telemetry_bytes',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_bytes_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_bytes_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_bytes_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_bytes_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryBytesRow),
  primitiveTelemetryDate: __table({
    name: 'primitive_telemetry_date',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_date_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_date_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_date_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_date_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryDateRow),
  primitiveTelemetryDateTime: __table({
    name: 'primitive_telemetry_date_time',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_date_time_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_date_time_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_date_time_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_date_time_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryDateTimeRow),
  primitiveTelemetryDecimal: __table({
    name: 'primitive_telemetry_decimal',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_decimal_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_decimal_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_decimal_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_decimal_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryDecimalRow),
  primitiveTelemetryDouble: __table({
    name: 'primitive_telemetry_double',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_double_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_double_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_double_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_double_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryDoubleRow),
  primitiveTelemetryDuration: __table({
    name: 'primitive_telemetry_duration',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_duration_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_duration_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_duration_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_duration_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryDurationRow),
  primitiveTelemetryFloat: __table({
    name: 'primitive_telemetry_float',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_float_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_float_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_float_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_float_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryFloatRow),
  primitiveTelemetryInteger: __table({
    name: 'primitive_telemetry_integer',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_integer_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_integer_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_integer_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_integer_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryIntegerRow),
  primitiveTelemetryLong: __table({
    name: 'primitive_telemetry_long',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_long_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_long_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_long_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_long_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryLongRow),
  primitiveTelemetryShort: __table({
    name: 'primitive_telemetry_short',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_short_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_short_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_short_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_short_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryShortRow),
  primitiveTelemetryString: __table({
    name: 'primitive_telemetry_string',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_string_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_string_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_string_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_string_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryStringRow),
  primitiveTelemetryTime: __table({
    name: 'primitive_telemetry_time',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_time_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_time_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_time_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_time_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryTimeRow),
  primitiveTelemetryUnsignedByte: __table({
    name: 'primitive_telemetry_unsigned_byte',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_unsigned_byte_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_unsigned_byte_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_unsigned_byte_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_unsigned_byte_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryUnsignedByteRow),
  primitiveTelemetryUnsignedInteger: __table({
    name: 'primitive_telemetry_unsigned_integer',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_unsigned_integer_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_unsigned_integer_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_unsigned_integer_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_unsigned_integer_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryUnsignedIntegerRow),
  primitiveTelemetryUnsignedLong: __table({
    name: 'primitive_telemetry_unsigned_long',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_unsigned_long_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_unsigned_long_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_unsigned_long_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_unsigned_long_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryUnsignedLongRow),
  primitiveTelemetryUnsignedShort: __table({
    name: 'primitive_telemetry_unsigned_short',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_unsigned_short_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_unsigned_short_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_unsigned_short_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_unsigned_short_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryUnsignedShortRow),
  primitiveTelemetryUuid: __table({
    name: 'primitive_telemetry_uuid',
    indexes: [
      { accessor: 'stream_id', name: 'primitive_telemetry_uuid_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'primitive_telemetry_uuid_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'primitive_telemetry_uuid_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'primitive_telemetry_uuid_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, PrimitiveTelemetryUuidRow),
  projectAlertNotification: __table({
    name: 'project_alert_notification',
    indexes: [
      { accessor: 'event_id', name: 'project_alert_notification_event_id_idx_btree', algorithm: 'btree', columns: [
        'eventId',
      ] },
      { accessor: 'id', name: 'project_alert_notification_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'project_id', name: 'project_alert_notification_project_id_idx_btree', algorithm: 'btree', columns: [
        'projectId',
      ] },
    ],
    constraints: [
      { name: 'project_alert_notification_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ProjectAlertNotificationRow),
  restApiSpec: __table({
    name: 'rest_api_spec',
    indexes: [
      { accessor: 'name', name: 'rest_api_spec_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
      { accessor: 'spec_id', name: 'rest_api_spec_spec_id_idx_btree', algorithm: 'btree', columns: [
        'specId',
      ] },
    ],
    constraints: [
      { name: 'rest_api_spec_name_key', constraint: 'unique', columns: ['name'] },
      { name: 'rest_api_spec_spec_id_key', constraint: 'unique', columns: ['specId'] },
    ],
  }, RestApiSpecRow),
  restEndpoint: __table({
    name: 'rest_endpoint',
    indexes: [
      { accessor: 'endpoint_id', name: 'rest_endpoint_endpoint_id_idx_btree', algorithm: 'btree', columns: [
        'endpointId',
      ] },
      { accessor: 'name', name: 'rest_endpoint_name_idx_btree', algorithm: 'btree', columns: [
        'name',
      ] },
    ],
    constraints: [
      { name: 'rest_endpoint_endpoint_id_key', constraint: 'unique', columns: ['endpointId'] },
      { name: 'rest_endpoint_name_key', constraint: 'unique', columns: ['name'] },
    ],
  }, RestEndpointRow),
  restPollLog: __table({
    name: 'rest_poll_log',
    indexes: [
      { accessor: 'polling_id', name: 'rest_poll_log_polling_id_idx_btree', algorithm: 'btree', columns: [
        'pollingId',
      ] },
    ],
    constraints: [
      { name: 'rest_poll_log_polling_id_key', constraint: 'unique', columns: ['pollingId'] },
    ],
  }, RestPollLogRow),
  restPolling: __table({
    name: 'rest_polling',
    indexes: [
      { accessor: 'endpoint_id', name: 'rest_polling_endpoint_id_idx_btree', algorithm: 'btree', columns: [
        'endpointId',
      ] },
      { accessor: 'polling_id', name: 'rest_polling_polling_id_idx_btree', algorithm: 'btree', columns: [
        'pollingId',
      ] },
    ],
    constraints: [
      { name: 'rest_polling_polling_id_key', constraint: 'unique', columns: ['pollingId'] },
    ],
  }, RestPollingRow),
  restResponseMapping: __table({
    name: 'rest_response_mapping',
    indexes: [
      { accessor: 'endpoint_id', name: 'rest_response_mapping_endpoint_id_idx_btree', algorithm: 'btree', columns: [
        'endpointId',
      ] },
      { accessor: 'mapping_id', name: 'rest_response_mapping_mapping_id_idx_btree', algorithm: 'btree', columns: [
        'mappingId',
      ] },
    ],
    constraints: [
      { name: 'rest_response_mapping_mapping_id_key', constraint: 'unique', columns: ['mappingId'] },
    ],
  }, RestResponseMappingRow),
  twinTransform: __table({
    name: 'twin_transform',
    indexes: [
      { accessor: 'stream_id', name: 'twin_transform_stream_id_idx_btree', algorithm: 'btree', columns: [
        'streamId',
      ] },
      { accessor: 'stream_name', name: 'twin_transform_stream_name_idx_btree', algorithm: 'btree', columns: [
        'streamName',
      ] },
    ],
    constraints: [
      { name: 'twin_transform_stream_id_key', constraint: 'unique', columns: ['streamId'] },
      { name: 'twin_transform_stream_name_key', constraint: 'unique', columns: ['streamName'] },
    ],
  }, TwinTransformRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("acknowledge_alert_event", AcknowledgeAlertEventReducer),
  __reducerSchema("add_alert_target", AddAlertTargetReducer),
  __reducerSchema("cleanup_orphaned_streams", CleanupOrphanedStreamsReducer),
  __reducerSchema("clear_alert_events", ClearAlertEventsReducer),
  __reducerSchema("clear_all_data", ClearAllDataReducer),
  __reducerSchema("clear_old_poll_logs", ClearOldPollLogsReducer),
  __reducerSchema("clear_stopped_polls", ClearStoppedPollsReducer),
  __reducerSchema("create_alert_rule", CreateAlertRuleReducer),
  __reducerSchema("create_computed_channel", CreateComputedChannelReducer),
  __reducerSchema("create_new_stream", CreateNewStreamReducer),
  __reducerSchema("create_response_mapping", CreateResponseMappingReducer),
  __reducerSchema("create_rest_endpoint", CreateRestEndpointReducer),
  __reducerSchema("delete_alert_rule", DeleteAlertRuleReducer),
  __reducerSchema("delete_computed_channel", DeleteComputedChannelReducer),
  __reducerSchema("delete_openapi_spec", DeleteOpenapiSpecReducer),
  __reducerSchema("delete_response_mapping", DeleteResponseMappingReducer),
  __reducerSchema("delete_rest_credentials", DeleteRestCredentialsReducer),
  __reducerSchema("delete_rest_endpoint", DeleteRestEndpointReducer),
  __reducerSchema("delete_stream_by_stream_name", DeleteStreamByStreamNameReducer),
  __reducerSchema("disable_rest_endpoint", DisableRestEndpointReducer),
  __reducerSchema("dismiss_alert_event", DismissAlertEventReducer),
  __reducerSchema("dismiss_alert_notification", DismissAlertNotificationReducer),
  __reducerSchema("enable_rest_endpoint", EnableRestEndpointReducer),
  __reducerSchema("export_all_telemetry", ExportAllTelemetryReducer),
  __reducerSchema("export_telemetry_by_stream_id", ExportTelemetryByStreamIdReducer),
  __reducerSchema("export_telemetry_by_stream_name", ExportTelemetryByStreamNameReducer),
  __reducerSchema("export_telemetry_streams", ExportTelemetryStreamsReducer),
  __reducerSchema("get_module_info", GetModuleInfoReducer),
  __reducerSchema("import_dtdl_graph_from_json", ImportDtdlGraphFromJsonReducer),
  __reducerSchema("import_telemetry_from_json", ImportTelemetryFromJsonReducer),
  __reducerSchema("import_telemetry_from_json_with_string_mode", ImportTelemetryFromJsonWithStringModeReducer),
  __reducerSchema("list_alert_targets", ListAlertTargetsReducer),
  __reducerSchema("map_response_field", MapResponseFieldReducer),
  __reducerSchema("pause_rest_polling", PauseRestPollingReducer),
  __reducerSchema("post_restore_normalize", PostRestoreNormalizeReducer),
  __reducerSchema("register_admin_service", RegisterAdminServiceReducer),
  __reducerSchema("remove_alert_target", RemoveAlertTargetReducer),
  __reducerSchema("remove_module_user", RemoveModuleUserReducer),
  __reducerSchema("reparse_openapi_spec", ReparseOpenapiSpecReducer),
  __reducerSchema("replace_openapi_spec", ReplaceOpenapiSpecReducer),
  __reducerSchema("resume_rest_polling", ResumeRestPollingReducer),
  __reducerSchema("send_complex_telemetry_by_stream_id", SendComplexTelemetryByStreamIdReducer),
  __reducerSchema("send_complex_telemetry_by_stream_name", SendComplexTelemetryByStreamNameReducer),
  __reducerSchema("send_location_by_stream_id", SendLocationByStreamIdReducer),
  __reducerSchema("send_location_by_stream_name", SendLocationByStreamNameReducer),
  __reducerSchema("send_rotation_by_stream_id", SendRotationByStreamIdReducer),
  __reducerSchema("send_rotation_by_stream_name", SendRotationByStreamNameReducer),
  __reducerSchema("send_telemetry_batch", SendTelemetryBatchReducer),
  __reducerSchema("send_telemetry_bool_by_stream_id", SendTelemetryBoolByStreamIdReducer),
  __reducerSchema("send_telemetry_bool_by_stream_name", SendTelemetryBoolByStreamNameReducer),
  __reducerSchema("send_telemetry_byte_by_stream_id", SendTelemetryByteByStreamIdReducer),
  __reducerSchema("send_telemetry_byte_by_stream_name", SendTelemetryByteByStreamNameReducer),
  __reducerSchema("send_telemetry_bytes_by_stream_id", SendTelemetryBytesByStreamIdReducer),
  __reducerSchema("send_telemetry_bytes_by_stream_name", SendTelemetryBytesByStreamNameReducer),
  __reducerSchema("send_telemetry_date_by_stream_id", SendTelemetryDateByStreamIdReducer),
  __reducerSchema("send_telemetry_date_by_stream_name", SendTelemetryDateByStreamNameReducer),
  __reducerSchema("send_telemetry_date_time_by_stream_id", SendTelemetryDateTimeByStreamIdReducer),
  __reducerSchema("send_telemetry_date_time_by_stream_name", SendTelemetryDateTimeByStreamNameReducer),
  __reducerSchema("send_telemetry_decimal_by_stream_id", SendTelemetryDecimalByStreamIdReducer),
  __reducerSchema("send_telemetry_decimal_by_stream_name", SendTelemetryDecimalByStreamNameReducer),
  __reducerSchema("send_telemetry_double_by_stream_id", SendTelemetryDoubleByStreamIdReducer),
  __reducerSchema("send_telemetry_double_by_stream_name", SendTelemetryDoubleByStreamNameReducer),
  __reducerSchema("send_telemetry_duration_by_stream_id", SendTelemetryDurationByStreamIdReducer),
  __reducerSchema("send_telemetry_duration_by_stream_name", SendTelemetryDurationByStreamNameReducer),
  __reducerSchema("send_telemetry_float_by_stream_id", SendTelemetryFloatByStreamIdReducer),
  __reducerSchema("send_telemetry_float_by_stream_name", SendTelemetryFloatByStreamNameReducer),
  __reducerSchema("send_telemetry_integer_by_stream_id", SendTelemetryIntegerByStreamIdReducer),
  __reducerSchema("send_telemetry_integer_by_stream_name", SendTelemetryIntegerByStreamNameReducer),
  __reducerSchema("send_telemetry_long_by_stream_id", SendTelemetryLongByStreamIdReducer),
  __reducerSchema("send_telemetry_long_by_stream_name", SendTelemetryLongByStreamNameReducer),
  __reducerSchema("send_telemetry_short_by_stream_id", SendTelemetryShortByStreamIdReducer),
  __reducerSchema("send_telemetry_short_by_stream_name", SendTelemetryShortByStreamNameReducer),
  __reducerSchema("send_telemetry_string_by_stream_id", SendTelemetryStringByStreamIdReducer),
  __reducerSchema("send_telemetry_string_by_stream_name", SendTelemetryStringByStreamNameReducer),
  __reducerSchema("send_telemetry_time_by_stream_id", SendTelemetryTimeByStreamIdReducer),
  __reducerSchema("send_telemetry_time_by_stream_name", SendTelemetryTimeByStreamNameReducer),
  __reducerSchema("send_telemetry_unsigned_byte_by_stream_id", SendTelemetryUnsignedByteByStreamIdReducer),
  __reducerSchema("send_telemetry_unsigned_byte_by_stream_name", SendTelemetryUnsignedByteByStreamNameReducer),
  __reducerSchema("send_telemetry_unsigned_integer_by_stream_id", SendTelemetryUnsignedIntegerByStreamIdReducer),
  __reducerSchema("send_telemetry_unsigned_integer_by_stream_name", SendTelemetryUnsignedIntegerByStreamNameReducer),
  __reducerSchema("send_telemetry_unsigned_long_by_stream_id", SendTelemetryUnsignedLongByStreamIdReducer),
  __reducerSchema("send_telemetry_unsigned_long_by_stream_name", SendTelemetryUnsignedLongByStreamNameReducer),
  __reducerSchema("send_telemetry_unsigned_short_by_stream_id", SendTelemetryUnsignedShortByStreamIdReducer),
  __reducerSchema("send_telemetry_unsigned_short_by_stream_name", SendTelemetryUnsignedShortByStreamNameReducer),
  __reducerSchema("send_telemetry_uuid_by_stream_id", SendTelemetryUuidByStreamIdReducer),
  __reducerSchema("send_telemetry_uuid_by_stream_name", SendTelemetryUuidByStreamNameReducer),
  __reducerSchema("send_transform_by_stream_id", SendTransformByStreamIdReducer),
  __reducerSchema("send_transform_by_stream_name", SendTransformByStreamNameReducer),
  __reducerSchema("set_alert_condition_v2", SetAlertConditionV2Reducer),
  __reducerSchema("set_channel_aggregate_v2", SetChannelAggregateV2Reducer),
  __reducerSchema("set_channel_enabled", SetChannelEnabledReducer),
  __reducerSchema("set_channel_sequence_op", SetChannelSequenceOpReducer),
  __reducerSchema("set_module_user_role", SetModuleUserRoleReducer),
  __reducerSchema("set_project_scope", SetProjectScopeReducer),
  __reducerSchema("set_project_tenant_config", SetProjectTenantConfigReducer),
  __reducerSchema("set_response_mapping_scale", SetResponseMappingScaleReducer),
  __reducerSchema("set_rest_credentials", SetRestCredentialsReducer),
  __reducerSchema("start_alert_evaluator", StartAlertEvaluatorReducer),
  __reducerSchema("start_alert_history_gc", StartAlertHistoryGcReducer),
  __reducerSchema("start_alert_webhook_delivery", StartAlertWebhookDeliveryReducer),
  __reducerSchema("start_channel_engine", StartChannelEngineReducer),
  __reducerSchema("start_rest_poll_log_gc", StartRestPollLogGcReducer),
  __reducerSchema("start_rest_polling", StartRestPollingReducer),
  __reducerSchema("stop_alert_evaluator", StopAlertEvaluatorReducer),
  __reducerSchema("stop_alert_webhook_delivery", StopAlertWebhookDeliveryReducer),
  __reducerSchema("stop_all_rest_polling", StopAllRestPollingReducer),
  __reducerSchema("stop_channel_engine", StopChannelEngineReducer),
  __reducerSchema("stop_rest_polling", StopRestPollingReducer),
  __reducerSchema("toggle_alert_rule", ToggleAlertRuleReducer),
  __reducerSchema("toggle_alert_target", ToggleAlertTargetReducer),
  __reducerSchema("transfer_admin_service", TransferAdminServiceReducer),
  __reducerSchema("unmap_response_field", UnmapResponseFieldReducer),
  __reducerSchema("update_alert_rule", UpdateAlertRuleReducer),
  __reducerSchema("update_computed_channel", UpdateComputedChannelReducer),
  __reducerSchema("update_response_mapping", UpdateResponseMappingReducer),
  __reducerSchema("update_rest_endpoint", UpdateRestEndpointReducer),
  __reducerSchema("update_stream_name_by_stream_id", UpdateStreamNameByStreamIdReducer),
  __reducerSchema("upload_openapi_spec", UploadOpenapiSpecReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
  __procedureSchema("replay_telemetry", ReplayTelemetryProcedure.params, ReplayTelemetryProcedure.returnType),
  __procedureSchema("replay_transforms", ReplayTransformsProcedure.params, ReplayTransformsProcedure.returnType),
  __procedureSchema("telemetry_window", TelemetryWindowProcedure.params, TelemetryWindowProcedure.returnType),
  __procedureSchema("test_rest_endpoint", TestRestEndpointProcedure.params, TestRestEndpointProcedure.returnType),
  __procedureSchema("transform_window", TransformWindowProcedure.params, TransformWindowProcedure.returnType),
);

type __SchemaWithTableAccessorAliases = Omit<typeof tablesSchema.schemaType, "tables"> & {
  tables: typeof tablesSchema.schemaType.tables & {
    /** @deprecated Use `alertEvent` instead. This alias will be removed in the next major version. */
    readonly "alert_event": Omit<typeof tablesSchema.schemaType.tables["alertEvent"], "accessorName"> & { readonly accessorName: "alert_event" };
    /** @deprecated Use `alertRule` instead. This alias will be removed in the next major version. */
    readonly "alert_rule": Omit<typeof tablesSchema.schemaType.tables["alertRule"], "accessorName"> & { readonly accessorName: "alert_rule" };
    /** @deprecated Use `alertTargetListEvent` instead. This alias will be removed in the next major version. */
    readonly "alert_target_list_event": Omit<typeof tablesSchema.schemaType.tables["alertTargetListEvent"], "accessorName"> & { readonly accessorName: "alert_target_list_event" };
    /** @deprecated Use `complexTelemetry` instead. This alias will be removed in the next major version. */
    readonly "complex_telemetry": Omit<typeof tablesSchema.schemaType.tables["complexTelemetry"], "accessorName"> & { readonly accessorName: "complex_telemetry" };
    /** @deprecated Use `computedChannel` instead. This alias will be removed in the next major version. */
    readonly "computed_channel": Omit<typeof tablesSchema.schemaType.tables["computedChannel"], "accessorName"> & { readonly accessorName: "computed_channel" };
    /** @deprecated Use `exportResultEvent` instead. This alias will be removed in the next major version. */
    readonly "export_result_event": Omit<typeof tablesSchema.schemaType.tables["exportResultEvent"], "accessorName"> & { readonly accessorName: "export_result_event" };
    /** @deprecated Use `moduleUser` instead. This alias will be removed in the next major version. */
    readonly "module_user": Omit<typeof tablesSchema.schemaType.tables["moduleUser"], "accessorName"> & { readonly accessorName: "module_user" };
    /** @deprecated Use `primitiveTelemetryBool` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_bool": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryBool"], "accessorName"> & { readonly accessorName: "primitive_telemetry_bool" };
    /** @deprecated Use `primitiveTelemetryByte` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_byte": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryByte"], "accessorName"> & { readonly accessorName: "primitive_telemetry_byte" };
    /** @deprecated Use `primitiveTelemetryBytes` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_bytes": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryBytes"], "accessorName"> & { readonly accessorName: "primitive_telemetry_bytes" };
    /** @deprecated Use `primitiveTelemetryDate` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_date": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryDate"], "accessorName"> & { readonly accessorName: "primitive_telemetry_date" };
    /** @deprecated Use `primitiveTelemetryDateTime` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_date_time": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryDateTime"], "accessorName"> & { readonly accessorName: "primitive_telemetry_date_time" };
    /** @deprecated Use `primitiveTelemetryDecimal` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_decimal": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryDecimal"], "accessorName"> & { readonly accessorName: "primitive_telemetry_decimal" };
    /** @deprecated Use `primitiveTelemetryDouble` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_double": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryDouble"], "accessorName"> & { readonly accessorName: "primitive_telemetry_double" };
    /** @deprecated Use `primitiveTelemetryDuration` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_duration": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryDuration"], "accessorName"> & { readonly accessorName: "primitive_telemetry_duration" };
    /** @deprecated Use `primitiveTelemetryFloat` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_float": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryFloat"], "accessorName"> & { readonly accessorName: "primitive_telemetry_float" };
    /** @deprecated Use `primitiveTelemetryInteger` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_integer": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryInteger"], "accessorName"> & { readonly accessorName: "primitive_telemetry_integer" };
    /** @deprecated Use `primitiveTelemetryLong` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_long": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryLong"], "accessorName"> & { readonly accessorName: "primitive_telemetry_long" };
    /** @deprecated Use `primitiveTelemetryShort` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_short": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryShort"], "accessorName"> & { readonly accessorName: "primitive_telemetry_short" };
    /** @deprecated Use `primitiveTelemetryString` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_string": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryString"], "accessorName"> & { readonly accessorName: "primitive_telemetry_string" };
    /** @deprecated Use `primitiveTelemetryTime` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_time": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryTime"], "accessorName"> & { readonly accessorName: "primitive_telemetry_time" };
    /** @deprecated Use `primitiveTelemetryUnsignedByte` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_unsigned_byte": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryUnsignedByte"], "accessorName"> & { readonly accessorName: "primitive_telemetry_unsigned_byte" };
    /** @deprecated Use `primitiveTelemetryUnsignedInteger` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_unsigned_integer": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryUnsignedInteger"], "accessorName"> & { readonly accessorName: "primitive_telemetry_unsigned_integer" };
    /** @deprecated Use `primitiveTelemetryUnsignedLong` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_unsigned_long": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryUnsignedLong"], "accessorName"> & { readonly accessorName: "primitive_telemetry_unsigned_long" };
    /** @deprecated Use `primitiveTelemetryUnsignedShort` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_unsigned_short": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryUnsignedShort"], "accessorName"> & { readonly accessorName: "primitive_telemetry_unsigned_short" };
    /** @deprecated Use `primitiveTelemetryUuid` instead. This alias will be removed in the next major version. */
    readonly "primitive_telemetry_uuid": Omit<typeof tablesSchema.schemaType.tables["primitiveTelemetryUuid"], "accessorName"> & { readonly accessorName: "primitive_telemetry_uuid" };
    /** @deprecated Use `projectAlertNotification` instead. This alias will be removed in the next major version. */
    readonly "project_alert_notification": Omit<typeof tablesSchema.schemaType.tables["projectAlertNotification"], "accessorName"> & { readonly accessorName: "project_alert_notification" };
    /** @deprecated Use `restApiSpec` instead. This alias will be removed in the next major version. */
    readonly "rest_api_spec": Omit<typeof tablesSchema.schemaType.tables["restApiSpec"], "accessorName"> & { readonly accessorName: "rest_api_spec" };
    /** @deprecated Use `restEndpoint` instead. This alias will be removed in the next major version. */
    readonly "rest_endpoint": Omit<typeof tablesSchema.schemaType.tables["restEndpoint"], "accessorName"> & { readonly accessorName: "rest_endpoint" };
    /** @deprecated Use `restPollLog` instead. This alias will be removed in the next major version. */
    readonly "rest_poll_log": Omit<typeof tablesSchema.schemaType.tables["restPollLog"], "accessorName"> & { readonly accessorName: "rest_poll_log" };
    /** @deprecated Use `restPolling` instead. This alias will be removed in the next major version. */
    readonly "rest_polling": Omit<typeof tablesSchema.schemaType.tables["restPolling"], "accessorName"> & { readonly accessorName: "rest_polling" };
    /** @deprecated Use `restResponseMapping` instead. This alias will be removed in the next major version. */
    readonly "rest_response_mapping": Omit<typeof tablesSchema.schemaType.tables["restResponseMapping"], "accessorName"> & { readonly accessorName: "rest_response_mapping" };
    /** @deprecated Use `twinTransform` instead. This alias will be removed in the next major version. */
    readonly "twin_transform": Omit<typeof tablesSchema.schemaType.tables["twinTransform"], "accessorName"> & { readonly accessorName: "twin_transform" };
  };
};

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.14.0" as const,
  },
  tables: tablesSchema.schemaType.tables as __SchemaWithTableAccessorAliases["tables"],
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  __SchemaWithTableAccessorAliases,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

const tableAccessorAliases = {
  "alert_event": "alertEvent",
  "alert_rule": "alertRule",
  "alert_target_list_event": "alertTargetListEvent",
  "complex_telemetry": "complexTelemetry",
  "computed_channel": "computedChannel",
  "export_result_event": "exportResultEvent",
  "module_user": "moduleUser",
  "primitive_telemetry_bool": "primitiveTelemetryBool",
  "primitive_telemetry_byte": "primitiveTelemetryByte",
  "primitive_telemetry_bytes": "primitiveTelemetryBytes",
  "primitive_telemetry_date": "primitiveTelemetryDate",
  "primitive_telemetry_date_time": "primitiveTelemetryDateTime",
  "primitive_telemetry_decimal": "primitiveTelemetryDecimal",
  "primitive_telemetry_double": "primitiveTelemetryDouble",
  "primitive_telemetry_duration": "primitiveTelemetryDuration",
  "primitive_telemetry_float": "primitiveTelemetryFloat",
  "primitive_telemetry_integer": "primitiveTelemetryInteger",
  "primitive_telemetry_long": "primitiveTelemetryLong",
  "primitive_telemetry_short": "primitiveTelemetryShort",
  "primitive_telemetry_string": "primitiveTelemetryString",
  "primitive_telemetry_time": "primitiveTelemetryTime",
  "primitive_telemetry_unsigned_byte": "primitiveTelemetryUnsignedByte",
  "primitive_telemetry_unsigned_integer": "primitiveTelemetryUnsignedInteger",
  "primitive_telemetry_unsigned_long": "primitiveTelemetryUnsignedLong",
  "primitive_telemetry_unsigned_short": "primitiveTelemetryUnsignedShort",
  "primitive_telemetry_uuid": "primitiveTelemetryUuid",
  "project_alert_notification": "projectAlertNotification",
  "rest_api_spec": "restApiSpec",
  "rest_endpoint": "restEndpoint",
  "rest_poll_log": "restPollLog",
  "rest_polling": "restPolling",
  "rest_response_mapping": "restResponseMapping",
  "twin_transform": "twinTransform",
} as const;

function __withTableAccessorAliases<T extends object>(target: T, freeze = false): T {
  const out = Object.create(Object.getPrototypeOf(target)) as T & Record<string, unknown>;
  Object.defineProperties(out, Object.getOwnPropertyDescriptors(target));
  for (const [deprecatedAccessor, targetAccessor] of Object.entries(tableAccessorAliases)) {
    if (deprecatedAccessor in out) {
      continue;
    }
    Object.defineProperty(out, deprecatedAccessor, {
      enumerable: true,
      configurable: false,
      get: () => out[targetAccessor],
    });
  }
  return freeze ? Object.freeze(out) : out;
}

type __DbViewBase = __DbConnectionImpl<typeof REMOTE_MODULE>["db"];
export type DbView = __DbViewBase & {
  /** @deprecated Use `alertEvent` instead. This alias will be removed in the next major version. */
  readonly "alert_event": __DbViewBase["alertEvent"];
  /** @deprecated Use `alertRule` instead. This alias will be removed in the next major version. */
  readonly "alert_rule": __DbViewBase["alertRule"];
  /** @deprecated Use `alertTargetListEvent` instead. This alias will be removed in the next major version. */
  readonly "alert_target_list_event": __DbViewBase["alertTargetListEvent"];
  /** @deprecated Use `complexTelemetry` instead. This alias will be removed in the next major version. */
  readonly "complex_telemetry": __DbViewBase["complexTelemetry"];
  /** @deprecated Use `computedChannel` instead. This alias will be removed in the next major version. */
  readonly "computed_channel": __DbViewBase["computedChannel"];
  /** @deprecated Use `exportResultEvent` instead. This alias will be removed in the next major version. */
  readonly "export_result_event": __DbViewBase["exportResultEvent"];
  /** @deprecated Use `moduleUser` instead. This alias will be removed in the next major version. */
  readonly "module_user": __DbViewBase["moduleUser"];
  /** @deprecated Use `primitiveTelemetryBool` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_bool": __DbViewBase["primitiveTelemetryBool"];
  /** @deprecated Use `primitiveTelemetryByte` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_byte": __DbViewBase["primitiveTelemetryByte"];
  /** @deprecated Use `primitiveTelemetryBytes` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_bytes": __DbViewBase["primitiveTelemetryBytes"];
  /** @deprecated Use `primitiveTelemetryDate` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_date": __DbViewBase["primitiveTelemetryDate"];
  /** @deprecated Use `primitiveTelemetryDateTime` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_date_time": __DbViewBase["primitiveTelemetryDateTime"];
  /** @deprecated Use `primitiveTelemetryDecimal` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_decimal": __DbViewBase["primitiveTelemetryDecimal"];
  /** @deprecated Use `primitiveTelemetryDouble` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_double": __DbViewBase["primitiveTelemetryDouble"];
  /** @deprecated Use `primitiveTelemetryDuration` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_duration": __DbViewBase["primitiveTelemetryDuration"];
  /** @deprecated Use `primitiveTelemetryFloat` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_float": __DbViewBase["primitiveTelemetryFloat"];
  /** @deprecated Use `primitiveTelemetryInteger` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_integer": __DbViewBase["primitiveTelemetryInteger"];
  /** @deprecated Use `primitiveTelemetryLong` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_long": __DbViewBase["primitiveTelemetryLong"];
  /** @deprecated Use `primitiveTelemetryShort` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_short": __DbViewBase["primitiveTelemetryShort"];
  /** @deprecated Use `primitiveTelemetryString` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_string": __DbViewBase["primitiveTelemetryString"];
  /** @deprecated Use `primitiveTelemetryTime` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_time": __DbViewBase["primitiveTelemetryTime"];
  /** @deprecated Use `primitiveTelemetryUnsignedByte` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_unsigned_byte": __DbViewBase["primitiveTelemetryUnsignedByte"];
  /** @deprecated Use `primitiveTelemetryUnsignedInteger` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_unsigned_integer": __DbViewBase["primitiveTelemetryUnsignedInteger"];
  /** @deprecated Use `primitiveTelemetryUnsignedLong` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_unsigned_long": __DbViewBase["primitiveTelemetryUnsignedLong"];
  /** @deprecated Use `primitiveTelemetryUnsignedShort` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_unsigned_short": __DbViewBase["primitiveTelemetryUnsignedShort"];
  /** @deprecated Use `primitiveTelemetryUuid` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_uuid": __DbViewBase["primitiveTelemetryUuid"];
  /** @deprecated Use `projectAlertNotification` instead. This alias will be removed in the next major version. */
  readonly "project_alert_notification": __DbViewBase["projectAlertNotification"];
  /** @deprecated Use `restApiSpec` instead. This alias will be removed in the next major version. */
  readonly "rest_api_spec": __DbViewBase["restApiSpec"];
  /** @deprecated Use `restEndpoint` instead. This alias will be removed in the next major version. */
  readonly "rest_endpoint": __DbViewBase["restEndpoint"];
  /** @deprecated Use `restPollLog` instead. This alias will be removed in the next major version. */
  readonly "rest_poll_log": __DbViewBase["restPollLog"];
  /** @deprecated Use `restPolling` instead. This alias will be removed in the next major version. */
  readonly "rest_polling": __DbViewBase["restPolling"];
  /** @deprecated Use `restResponseMapping` instead. This alias will be removed in the next major version. */
  readonly "rest_response_mapping": __DbViewBase["restResponseMapping"];
  /** @deprecated Use `twinTransform` instead. This alias will be removed in the next major version. */
  readonly "twin_transform": __DbViewBase["twinTransform"];
};

type __TablesBase = __QueryBuilder<typeof tablesSchema.schemaType>;
export type Tables = __TablesBase & {
  /** @deprecated Use `alertEvent` instead. This alias will be removed in the next major version. */
  readonly "alert_event": __TablesBase["alertEvent"];
  /** @deprecated Use `alertRule` instead. This alias will be removed in the next major version. */
  readonly "alert_rule": __TablesBase["alertRule"];
  /** @deprecated Use `alertTargetListEvent` instead. This alias will be removed in the next major version. */
  readonly "alert_target_list_event": __TablesBase["alertTargetListEvent"];
  /** @deprecated Use `complexTelemetry` instead. This alias will be removed in the next major version. */
  readonly "complex_telemetry": __TablesBase["complexTelemetry"];
  /** @deprecated Use `computedChannel` instead. This alias will be removed in the next major version. */
  readonly "computed_channel": __TablesBase["computedChannel"];
  /** @deprecated Use `exportResultEvent` instead. This alias will be removed in the next major version. */
  readonly "export_result_event": __TablesBase["exportResultEvent"];
  /** @deprecated Use `moduleUser` instead. This alias will be removed in the next major version. */
  readonly "module_user": __TablesBase["moduleUser"];
  /** @deprecated Use `primitiveTelemetryBool` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_bool": __TablesBase["primitiveTelemetryBool"];
  /** @deprecated Use `primitiveTelemetryByte` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_byte": __TablesBase["primitiveTelemetryByte"];
  /** @deprecated Use `primitiveTelemetryBytes` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_bytes": __TablesBase["primitiveTelemetryBytes"];
  /** @deprecated Use `primitiveTelemetryDate` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_date": __TablesBase["primitiveTelemetryDate"];
  /** @deprecated Use `primitiveTelemetryDateTime` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_date_time": __TablesBase["primitiveTelemetryDateTime"];
  /** @deprecated Use `primitiveTelemetryDecimal` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_decimal": __TablesBase["primitiveTelemetryDecimal"];
  /** @deprecated Use `primitiveTelemetryDouble` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_double": __TablesBase["primitiveTelemetryDouble"];
  /** @deprecated Use `primitiveTelemetryDuration` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_duration": __TablesBase["primitiveTelemetryDuration"];
  /** @deprecated Use `primitiveTelemetryFloat` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_float": __TablesBase["primitiveTelemetryFloat"];
  /** @deprecated Use `primitiveTelemetryInteger` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_integer": __TablesBase["primitiveTelemetryInteger"];
  /** @deprecated Use `primitiveTelemetryLong` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_long": __TablesBase["primitiveTelemetryLong"];
  /** @deprecated Use `primitiveTelemetryShort` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_short": __TablesBase["primitiveTelemetryShort"];
  /** @deprecated Use `primitiveTelemetryString` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_string": __TablesBase["primitiveTelemetryString"];
  /** @deprecated Use `primitiveTelemetryTime` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_time": __TablesBase["primitiveTelemetryTime"];
  /** @deprecated Use `primitiveTelemetryUnsignedByte` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_unsigned_byte": __TablesBase["primitiveTelemetryUnsignedByte"];
  /** @deprecated Use `primitiveTelemetryUnsignedInteger` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_unsigned_integer": __TablesBase["primitiveTelemetryUnsignedInteger"];
  /** @deprecated Use `primitiveTelemetryUnsignedLong` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_unsigned_long": __TablesBase["primitiveTelemetryUnsignedLong"];
  /** @deprecated Use `primitiveTelemetryUnsignedShort` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_unsigned_short": __TablesBase["primitiveTelemetryUnsignedShort"];
  /** @deprecated Use `primitiveTelemetryUuid` instead. This alias will be removed in the next major version. */
  readonly "primitive_telemetry_uuid": __TablesBase["primitiveTelemetryUuid"];
  /** @deprecated Use `projectAlertNotification` instead. This alias will be removed in the next major version. */
  readonly "project_alert_notification": __TablesBase["projectAlertNotification"];
  /** @deprecated Use `restApiSpec` instead. This alias will be removed in the next major version. */
  readonly "rest_api_spec": __TablesBase["restApiSpec"];
  /** @deprecated Use `restEndpoint` instead. This alias will be removed in the next major version. */
  readonly "rest_endpoint": __TablesBase["restEndpoint"];
  /** @deprecated Use `restPollLog` instead. This alias will be removed in the next major version. */
  readonly "rest_poll_log": __TablesBase["restPollLog"];
  /** @deprecated Use `restPolling` instead. This alias will be removed in the next major version. */
  readonly "rest_polling": __TablesBase["restPolling"];
  /** @deprecated Use `restResponseMapping` instead. This alias will be removed in the next major version. */
  readonly "rest_response_mapping": __TablesBase["restResponseMapping"];
  /** @deprecated Use `twinTransform` instead. This alias will be removed in the next major version. */
  readonly "twin_transform": __TablesBase["twinTransform"];
};

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
const tablesBase: __TablesBase = __makeQueryBuilder(tablesSchema.schemaType);
export const tables: Tables = __withTableAccessorAliases(tablesBase, true) as Tables;

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = Omit<__EventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = Omit<__ReducerEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = Omit<__SubscriptionEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for error events. */
export type ErrorContext = Omit<__ErrorContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  declare db: DbView;

  constructor(config: __DbConnectionConfig<typeof REMOTE_MODULE>) {
    super(config);
    this.db = __withTableAccessorAliases(this.db) as DbView;
  }

  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

